import Modal from 'services/modal';
import BaseService from 'services/base';

const IqcService = Object.assign(
  {
    save(config: any = {}, cb: Function = () => {}, dispatch: Function) {},
    publishIqcOrder(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认发布来料检验单？', ok, dispatch);
    },

    // 供应方确认检验单
    confirmIqcOrder(vfoXkNo, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          vfoXkNo,
          apiPath: '/verify/customerOrder/confirm',
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认此来料检验单？', ok, dispatch);
    },

    // 供应方退回检验单
    backIqcOrder(vfoXkNo, cb: Function = () => {}, dispatch: Function) {
      let ok = async (reason?) => {
        let config = {
          vfoXkNo,
          backReason: reason,
          apiPath: '/verify/customerOrder/back',
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showReject('确认退回？', ok, '退回', 'showReject', '', dispatch);
    },
    publish8dOrder(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认发布8D报告单？', ok, dispatch);
    },
    audit8dOrder(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认审核8D报告单？', ok, dispatch);
    },
    //检验完成
    checkFinishIqcOrder(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          apiPath: '/verify/order/checkFinish',
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认完成IQC检验？', ok, dispatch);
    }
  },
  BaseService
);

export default IqcService;
